import { render, staticRenderFns } from "./toolbar-checkbox.vue?vue&type=template&id=1040e9d6&"
import script from "./toolbar-checkbox.vue?vue&type=script&lang=js&"
export * from "./toolbar-checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports